"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6150],{

/***/ 59191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AccountCardList_AccountCardList; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AccountCardList/AccountCardList.js


var _excluded = ["title", "icon", "id", "links", "newEntry"],
  _excluded2 = ["id"];











var AccountCardList_Link = {
  button: Button/* default */.Z,
  "default": Link/* default */.Z
};
var AccountCard = function AccountCard(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    id = _ref.id,
    links = _ref.links,
    newEntry = _ref.newEntry,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handleClick = function handleClick(item) {
    publish('account:link:click', {
      category: title,
      item: item
    });
  };
  return react.createElement(Box/* default */.Z, (0,esm_extends/* default */.Z)({
    bg: "background.base",
    p: 3
  }, props), react.createElement(Flex/* default */.Z, {
    mb: 2,
    justifyContent: "space-between",
    alignItems: "center",
    "data-testid": "AccountCard-item-".concat(id)
  }, react.createElement(Flex/* default */.Z, {
    alignItems: "center"
  }, react.createElement(Heading/* default */.Z, {
    as: "h2",
    color: "text.primary",
    mr: 2
  }, title), newEntry && react.createElement(Box/* default */.Z, {
    p: 1,
    bg: "secondary.base",
    color: "#fff"
  }, "NOVO")), react.createElement(esm/* Icon */.JO$, {
    name: icon,
    color: "background.primary",
    width: 40,
    height: 40
  })), react.createElement(Flex/* default */.Z, {
    flexDirection: "column",
    gap: 2,
    alignItems: "flex-start"
  }, links.map(function (_ref2, index) {
    var type = _ref2.type,
      value = _ref2.value,
      href = _ref2.href;
    var LinkComponent = AccountCardList_Link[type || 'default'];
    return react.createElement(LinkComponent, {
      uppercase: false,
      key: value,
      as: "a",
      size: "small",
      href: href,
      onClick: function onClick() {
        return handleClick(value);
      },
      "data-testid": "AccountCard-link-".concat(id, "-").concat(index)
    }, value);
  })));
};
AccountCard.defaultProps = {
  newEntry: false
};
 false ? 0 : void 0;
var AccountCardList = function AccountCardList(_ref3) {
  var staticProps = _ref3["static"];
  return react.createElement(Grid/* default */.Z, {
    gridGap: "30px",
    height: "100%"
  }, staticProps.items.map(function (_ref4) {
    var id = _ref4.id,
      props = (0,objectWithoutProperties/* default */.Z)(_ref4, _excluded2);
    return react.createElement(AccountCard, (0,esm_extends/* default */.Z)({
      key: id,
      id: id
    }, props));
  }));
};
 false ? 0 : void 0;
AccountCardList.ssr = true;
/* harmony default export */ var AccountCardList_AccountCardList = ((0,withLayoutProps/* default */.Z)(AccountCardList));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AccountCardList/index.js


/***/ }),

/***/ 75120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AccountTitle_AccountTitle; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AccountTitle/AccountTitle.js




var AccountTitle = function AccountTitle(_ref) {
  var staticProps = _ref["static"];
  return react.createElement(Text/* default */.Z, {
    color: "text.base"
  }, react.createElement("span", null, "Ol\xE1"), react.createElement("strong", null, " ".concat(staticProps.accountName || 'Cliente', ". ")), react.createElement("span", null, staticProps.accountInfo));
};
 false ? 0 : void 0;
AccountTitle.ssr = true;
/* harmony default export */ var AccountTitle_AccountTitle = ((0,withLayoutProps/* default */.Z)(AccountTitle));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AccountTitle/index.js


/***/ }),

/***/ 76346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ActionCard_ActionCard; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ActionCard/index.js + 2 modules
var organisms_ActionCard = __webpack_require__(5530);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ActionCard/ActionCard.js






var ActionCard = function ActionCard(_ref) {
  var staticProps = _ref["static"];
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handleClick = function handleClick() {
    publish('action:click', staticProps);
  };
  return react.createElement(organisms_ActionCard/* default */.Z, (0,esm_extends/* default */.Z)({
    onButtonClick: handleClick
  }, staticProps));
};
 false ? 0 : void 0;
ActionCard.defaultProps = {
  "static": {},
  structure: {}
};
ActionCard.ssr = false;
/* harmony default export */ var ActionCard_ActionCard = ((0,withLayoutProps/* default */.Z)(ActionCard));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ActionCard/index.js


/***/ }),

/***/ 51653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HM": function() { return /* binding */ buildVideoProgressionEventData; },
/* harmony export */   "Wf": function() { return /* binding */ getCustomerId; },
/* harmony export */   "hX": function() { return /* binding */ trackImpression; },
/* harmony export */   "ob": function() { return /* binding */ trackClick; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var buildServerEventData = function buildServerEventData(banner, index) {
  return [{
    adType: 'SPONSORED_BANNER',
    position: index !== null && index !== void 0 ? index : 0,
    trackId: banner.trackId
  }];
};
var getCustomerId = function getCustomerId(staticCustomerId) {
  var CUSTOMER_ID = _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .cookiesConstants.CUSTOMER_ID */ .VD.CUSTOMER_ID;
  return staticCustomerId || (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(CUSTOMER_ID);
};
var buildVideoProgressionEventData = function buildVideoProgressionEventData() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 0 : _ref$duration,
    _ref$currentTime = _ref.currentTime,
    currentTime = _ref$currentTime === void 0 ? 0 : _ref$currentTime,
    _ref$progressPercent = _ref.progressPercent,
    progressPercent = _ref$progressPercent === void 0 ? 0 : _ref$progressPercent;
  return {
    video_current_time: currentTime,
    video_duration: duration,
    video_percent: progressPercent
  };
};
var trackClick = function trackClick(_ref2) {
  var banner = _ref2.banner,
    eventDetails = _ref2.eventDetails,
    isBannerCarousel = _ref2.isBannerCarousel,
    isVideo = _ref2.isVideo,
    screenName = _ref2.screenName,
    structure = _ref2.structure,
    trackingFunctions = _ref2.trackingFunctions;
  if (!banner) return;
  var publish = trackingFunctions.publish,
    sendServerClickEvents = trackingFunctions.sendServerClickEvents;
  var eventName = isVideo ? 'promotion:video:click' : 'promotion:click';
  var eventPayload = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .buildGtmBannerEventData */ .jv)(banner, isBannerCarousel, screenName, structure, eventDetails);
  sendServerClickEvents(buildServerEventData(banner, eventDetails.index));
  publish(eventName, eventPayload);
};
var trackImpression = function trackImpression(_ref3) {
  var banner = _ref3.banner,
    eventDetails = _ref3.eventDetails,
    isBannerCarousel = _ref3.isBannerCarousel,
    isVideo = _ref3.isVideo,
    publish = _ref3.publish,
    screenName = _ref3.screenName,
    sendServerImpressionEvents = _ref3.sendServerImpressionEvents,
    structure = _ref3.structure;
  var eventName = isVideo ? 'promotion:video:view' : 'promotion:view';
  var eventPayload = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .buildGtmBannerEventData */ .jv)(banner, isBannerCarousel, screenName, structure, eventDetails);
  sendServerImpressionEvents(buildServerEventData(banner, eventDetails.index));
  publish(eventName, eventPayload);
};


/***/ }),

/***/ 10369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* reexport */ AdsBanner_AdsBanner; }
});

// UNUSED EXPORTS: buildVideoProgressionEventData, getCustomerId, trackClick, trackImpression

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/AdsBannerSkeleton/index.js + 1 modules
var AdsBannerSkeleton = __webpack_require__(81126);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/contexts/index.js + 3 modules
var contexts = __webpack_require__(43812);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/AdsBanner/AdsBanner.utils.js
var AdsBanner_utils = __webpack_require__(51653);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBanner/useAdsBanners/index.js







var useAdsBanner = function useAdsBanner(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure;
  var adsPath = staticProps.adsPath,
    campaignId = staticProps.campaignId,
    staticCustomerId = staticProps.customerId,
    imageUrl = staticProps.imageUrl,
    index = staticProps.index,
    _staticProps$isBanner = staticProps.isBannerCarousel,
    isBannerCarousel = _staticProps$isBanner === void 0 ? false : _staticProps$isBanner,
    position = staticProps.position,
    redirectUrl = staticProps.redirectUrl,
    screenName = staticProps.screenName,
    size = staticProps.size,
    slot = staticProps.slot,
    trackId = staticProps.trackId;
  var customerId = (0,AdsBanner_utils/* getCustomerId */.Wf)(staticCustomerId);
  var _useAdsProvider = (0,contexts/* useAdsProvider */.J)(),
    ads = _useAdsProvider.ads,
    getBannerBySlot = _useAdsProvider.getBannerBySlot,
    isBannerLoading = _useAdsProvider.isLoading;
  var _useState = (0,react.useState)(imageUrl ? {
      campaignId: campaignId,
      imageUrl: imageUrl,
      redirectUrl: redirectUrl,
      trackId: trackId
    } : null),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    banner = _useState2[0],
    setBanner = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    hasViewed = _useState4[0],
    setHasViewed = _useState4[1];
  var inViewConfig = (0,react.useMemo)(function () {
    return {
      threshold: 0.5,
      triggerOnce: false
    };
  }, []);
  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)(inViewConfig),
    _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var adsEventsData = (0,react.useMemo)(function () {
    return {
      adsPath: adsPath,
      customerId: customerId,
      data: data,
      structure: structure
    };
  }, [adsPath, customerId, data, structure]);
  var _useAdsEvents = (0,esm.useAdsEvents)(adsEventsData),
    sendAdsClickEvents = _useAdsEvents.sendAdsClickEvents,
    sendAdsImpressionEvents = _useAdsEvents.sendAdsImpressionEvents;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var isVideo = (0,react.useMemo)(function () {
    var _banner$imageUrl$incl, _banner$imageUrl;
    return (_banner$imageUrl$incl = banner == null ? void 0 : (_banner$imageUrl = banner.imageUrl) == null ? void 0 : _banner$imageUrl.includes('.m3u8')) !== null && _banner$imageUrl$incl !== void 0 ? _banner$imageUrl$incl : false;
  }, [banner]);
  var handleClick = (0,react.useCallback)(function () {
    (0,AdsBanner_utils/* trackClick */.ob)({
      banner: banner,
      eventDetails: {
        index: index,
        position: position,
        size: size,
        slot: slot
      },
      isBannerCarousel: isBannerCarousel,
      isVideo: isVideo,
      screenName: screenName,
      structure: structure,
      trackingFunctions: {
        publish: publish,
        sendServerClickEvents: sendAdsClickEvents
      }
    });
  }, [banner, index, isBannerCarousel, isVideo, position, publish, screenName, sendAdsClickEvents, size, slot, structure]);
  (0,react.useEffect)(function () {
    if (isBannerCarousel || !getBannerBySlot || !ads) {
      return;
    }
    var bannersInSlot = getBannerBySlot(slot);
    var newBanner = bannersInSlot == null ? void 0 : bannersInSlot[0];
    setBanner(function (currentBanner) {
      if (newBanner && newBanner.trackId !== (currentBanner == null ? void 0 : currentBanner.trackId)) {
        return newBanner;
      }
      return currentBanner;
    });
  }, [ads, getBannerBySlot, isBannerCarousel, slot]);
  (0,react.useEffect)(function () {
    if (!inView || !banner || hasViewed) {
      return;
    }
    setHasViewed(true);
    (0,AdsBanner_utils/* trackImpression */.hX)({
      banner: banner,
      eventDetails: {
        index: index,
        position: position,
        size: size,
        slot: slot
      },
      isBannerCarousel: isBannerCarousel,
      isVideo: isVideo,
      publish: publish,
      screenName: screenName,
      sendServerImpressionEvents: sendAdsImpressionEvents,
      structure: structure
    });
  }, [banner, hasViewed, index, inView, isBannerCarousel, isVideo, position, publish, screenName, sendAdsImpressionEvents, size, slot, structure]);
  return {
    banner: banner,
    handleClick: handleClick,
    inView: inView,
    isBannerLoading: isBannerLoading,
    isVideo: isVideo,
    ref: ref
  };
};
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var stereo_ui_icons_build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../modules/build/esm/hooks/useHlsVideo.js
var useHlsVideo = __webpack_require__(81692);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBanner/Video/Video.styles.js

var _templateObject, _templateObject2, _templateObject3;

var MuteButton = styled_components_browser_esm["default"].button(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: 5%;\n  right: 2%;\n  background-color: rgba(0, 0, 0, 0.5);\n  border: none;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var StyledVideo = styled_components_browser_esm["default"].video(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  object-fit: cover;\n  object-position: center;\n  width: 100%;\n  height: 100%;\n"])));
var VideoWrapper = styled_components_browser_esm["default"].div(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  display: block;\n  margin: auto;\n  width: ", ";\n  height: ", ";\n"])), function (_ref) {
  var width = _ref.width;
  return width || '100%';
}, function (_ref2) {
  var height = _ref2.height;
  return height || 'auto';
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBanner/Video/Video.js










var Video = function Video(_ref) {
  var adsPath = _ref.adsPath,
    banner = _ref.banner,
    borderRadius = _ref.borderRadius,
    height = _ref.height,
    inView = _ref.inView,
    width = _ref.width;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var eventData = (0,react.useMemo)(function () {
    return {
      creative_slot: adsPath,
      video_title: banner.videoTitle || '',
      video_url: banner.imageUrl
    };
  }, [banner.imageUrl, adsPath, banner.videoTitle]);
  var handleStart = (0,react.useCallback)(function (videoInfo) {
    publish('promotion:video:start', (0,esm_extends/* default */.Z)({}, eventData, (0,AdsBanner_utils/* buildVideoProgressionEventData */.HM)(videoInfo)));
  }, [publish, eventData]);
  var handleComplete = (0,react.useCallback)(function (videoInfo) {
    publish('promotion:video:complete', (0,esm_extends/* default */.Z)({}, eventData, (0,AdsBanner_utils/* buildVideoProgressionEventData */.HM)(videoInfo)));
  }, [publish, eventData]);
  var handleProgress = (0,react.useCallback)(function (videoInfo) {
    publish('promotion:video:progress', (0,esm_extends/* default */.Z)({}, eventData, (0,AdsBanner_utils/* buildVideoProgressionEventData */.HM)(videoInfo)));
  }, [publish, eventData]);
  var _useHlsVideo = (0,useHlsVideo/* useHlsVideo */.Y)({
      autoPlay: true,
      onComplete: handleComplete,
      onProgress: handleProgress,
      onStart: handleStart,
      videoUrl: banner.imageUrl
    }),
    videoRef = _useHlsVideo.videoRef,
    isMuted = _useHlsVideo.isMuted,
    controls = _useHlsVideo.controls;
  (0,react.useEffect)(function () {
    if (isLoaded) {
      if (inView) {
        controls.play();
      } else {
        controls.pause();
      }
    }
  }, [inView, isLoaded, controls]);
  var handleMuteToggle = function handleMuteToggle(e) {
    e.preventDefault();
    e.stopPropagation();
    controls.toggleMute();
  };
  return react.createElement(VideoWrapper, {
    width: width,
    height: height
  }, react.createElement(AdsBannerSkeleton/* default */.Z, {
    isVisible: !isLoaded,
    width: width,
    height: height
  }), react.createElement(StyledVideo, {
    "aria-label": "Banner de ofertas do Magazine Luiza",
    ref: videoRef,
    height: height,
    width: width,
    playsInline: true,
    loop: true,
    style: {
      borderRadius: borderRadius,
      display: isLoaded ? 'block' : 'none',
      objectFit: 'cover'
    },
    onLoadedData: function onLoadedData() {
      return setIsLoaded(true);
    }
  }), isLoaded && react.createElement(MuteButton, {
    onClick: handleMuteToggle,
    "aria-label": isMuted ? 'Ativar som do vídeo' : 'Desativar som do vídeo',
    type: "button"
  }, isMuted ? react.createElement(stereo_ui_icons_build_esm/* Muted */.rO2, {
    width: 24,
    height: 24,
    color: "white"
  }) : react.createElement(stereo_ui_icons_build_esm/* Unmuted */.I5R, {
    width: 24,
    height: 24,
    color: "white"
  })));
};
 false ? 0 : void 0;
Video.defaultProps = {
  borderRadius: '8px',
  height: '100%',
  inView: true,
  width: '100%'
};
/* harmony default export */ var Video_Video = (Video);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBanner/Video/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBanner/AdsBanner.js








var AdsBanner = function AdsBanner(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure;
  var _staticProps$attribut = staticProps.attributeStyle,
    attributeStyle = _staticProps$attribut === void 0 ? {} : _staticProps$attribut,
    _staticProps$aspectRa = staticProps.aspectRatio,
    aspectRatio = _staticProps$aspectRa === void 0 ? 'auto' : _staticProps$aspectRa,
    adsPath = staticProps.adsPath,
    _staticProps$bg = staticProps.bg,
    bg = _staticProps$bg === void 0 ? 'transparent' : _staticProps$bg,
    _staticProps$borderRa = staticProps.borderRadius,
    borderRadius = _staticProps$borderRa === void 0 ? '8px' : _staticProps$borderRa,
    _staticProps$hasPlace = staticProps.hasPlaceholder,
    hasPlaceholder = _staticProps$hasPlace === void 0 ? false : _staticProps$hasPlace,
    height = staticProps.height,
    _staticProps$marginBo = staticProps.marginBottom,
    marginBottom = _staticProps$marginBo === void 0 ? '0px' : _staticProps$marginBo,
    _staticProps$marginTo = staticProps.marginTop,
    marginTop = _staticProps$marginTo === void 0 ? '0px' : _staticProps$marginTo,
    _staticProps$slot = staticProps.slot,
    slot = _staticProps$slot === void 0 ? '' : _staticProps$slot,
    width = staticProps.width;
  var _useAdsBanner = useAdsBanner({
      data: data,
      "static": staticProps,
      structure: structure
    }),
    banner = _useAdsBanner.banner,
    handleClick = _useAdsBanner.handleClick,
    inView = _useAdsBanner.inView,
    isBannerLoading = _useAdsBanner.isBannerLoading,
    isVideo = _useAdsBanner.isVideo,
    ref = _useAdsBanner.ref;
  var bannerRedirectUrl = (0,react.useMemo)(function () {
    if (!(banner == null ? void 0 : banner.redirectUrl)) return null;
    try {
      var url = new URL(banner.redirectUrl);
      url.searchParams.append('track_id', banner.trackId);
      url.searchParams.append('internal_ad', 'true');
      return url.toString();
    } catch (error) {
      console.error('invalid URL', error);
      return null;
    }
  }, [banner]);
  var shouldShowBanner = (banner == null ? void 0 : banner.redirectUrl) && !isBannerLoading;
  var shouldShowSkeleton = isBannerLoading && hasPlaceholder;
  if (!shouldShowBanner && !shouldShowSkeleton) {
    return null;
  }
  return react.createElement(react.Fragment, null, shouldShowBanner && react.createElement(atoms/* Box */.xu, {
    ref: ref,
    bg: bg,
    marginBottom: marginBottom,
    marginTop: marginTop
  }, react.createElement(atoms/* Link */.rU, {
    "data-testid": "ads-banner",
    href: bannerRedirectUrl,
    style: (0,esm_extends/* default */.Z)({
      aspectRatio: aspectRatio,
      display: 'block'
    }, attributeStyle),
    onMouseDown: handleClick
  }, react.createElement("span", {
    "data-testid": "ads-banner_screenshot",
    "ads-screenshot-id": "ads-banner_".concat(slot, "_").concat(banner == null ? void 0 : banner.campaignId)
  }), isVideo ? react.createElement(Video_Video, {
    adsPath: adsPath,
    banner: banner,
    borderRadius: borderRadius,
    inView: inView
  }) : react.createElement(atoms/* Image */.Ee, {
    alt: "Banner de ofertas do Magazine Luiza",
    src: banner.imageUrl,
    style: {
      borderRadius: borderRadius,
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center',
      width: '100%'
    }
  }))), shouldShowSkeleton && react.createElement(AdsBannerSkeleton/* default */.Z, {
    bg: bg,
    height: height,
    isVisible: true,
    width: width
  }));
};
AdsBanner.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
 false ? 0 : void 0;
AdsBanner.ssr = true;
/* harmony default export */ var AdsBanner_AdsBanner = ((0,withLayoutProps/* default */.Z)(AdsBanner));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBanner/index.js



/***/ }),

/***/ 81126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AdsBannerSkeleton_AdsBannerSkeleton; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/Skeleton/index.js + 2 modules
var Skeleton = __webpack_require__(83174);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBannerSkeleton/AdsBannerSkeleton.js




var AdsBannerSkeleton = function AdsBannerSkeleton(_ref) {
  var bg = _ref.bg,
    height = _ref.height,
    isVisible = _ref.isVisible,
    width = _ref.width;
  var safeHeight = height && height.trim() !== '' ? height : 'auto';
  var safeWidth = width && width.trim() !== '' ? width : '100%';
  return react.createElement(react.Fragment, null, isVisible && react.createElement(Flex/* default */.Z, {
    bg: bg,
    "data-testid": "ads-banner-skeleton",
    justifyContent: "center",
    width: "100%"
  }, react.createElement(Skeleton/* Skeleton */.O, {
    height: safeHeight,
    width: safeWidth,
    config: {
      body: [[{
        height: safeHeight,
        radius: 2,
        width: safeWidth,
        x: 0,
        y: 0
      }]],
      color: '#E8E8E8'
    }
  })));
};
AdsBannerSkeleton.defaultProps = {
  bg: 'transparent',
  height: 'auto',
  width: '100%'
};
 false ? 0 : void 0;
/* harmony default export */ var AdsBannerSkeleton_AdsBannerSkeleton = (AdsBannerSkeleton);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBannerSkeleton/index.js


/***/ }),

/***/ 70989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* reexport */ AdsBrand_AdsBrand; }
});

// UNUSED EXPORTS: getCustomerId, getUrlProduct, mountBrandUrl, parseBrand

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/contexts/index.js + 3 modules
var contexts = __webpack_require__(43812);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var build_esm = __webpack_require__(76613);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrands.utils.js


var getCustomerId = function getCustomerId(staticCustomerId) {
  var CUSTOMER_ID = esm/* cookiesConstants.CUSTOMER_ID */.VD.CUSTOMER_ID;
  return staticCustomerId || (0,esm/* getCookie */.ej)(CUSTOMER_ID);
};
var getUrlProduct = function getUrlProduct(path, structure, adsSellerId) {
  var url = new URL(path, structure.config.domain);
  url.searchParams.set('ads', 'patrocinado');
  if (adsSellerId) {
    url.searchParams.set('seller_id', adsSellerId);
  }
  return (0,esm/* parsePath */.cP)(url.pathname.concat(url.search));
};
var mountBrandUrl = function mountBrandUrl(brand) {
  var defaultUrl = '#';
  if (!brand || !brand.type || !brand.id) {
    return defaultUrl;
  }
  switch (brand.type) {
    case 'vendor':
      return "/lojista/".concat(brand.id);
    case 'url':
      return brand.id;
    case 'product':
      if (Array.isArray(brand == null ? void 0 : brand.products)) {
        var product = brand.products.find(function (p) {
          return p.id === brand.id;
        });
        return product && (product == null ? void 0 : product.path) ? product.path : defaultUrl;
      }
      return defaultUrl;
    default:
      return defaultUrl;
  }
};
var parseBrand = function parseBrand(brand, structure) {
  var _brand$products, _brand$content, _brand$content$creati;
  if (!brand) return null;
  var brandProducts = brand == null ? void 0 : (_brand$products = brand.products) == null ? void 0 : _brand$products.filter(function (product) {
    return product.price;
  }).map(function (product) {
    return (0,esm_extends/* default */.Z)({}, product, {
      path: getUrlProduct(product.path, structure, product.adsSellerId)
    });
  });
  return (0,esm_extends/* default */.Z)({}, brand, {
    content: (0,esm_extends/* default */.Z)({}, brand.content, {
      imageUrl: (brand == null ? void 0 : (_brand$content = brand.content) == null ? void 0 : (_brand$content$creati = _brand$content.creatives) == null ? void 0 : _brand$content$creati.length) ? brand.content.creatives[0] : null,
      redirectUrl: mountBrandUrl((0,esm_extends/* default */.Z)({}, brand, {
        products: brandProducts
      }))
    }),
    products: brandProducts
  });
};
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/useAdsBrands/index.js




function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }






var useAdsBrands = function useAdsBrands(_ref) {
  var _structure$route, _brand$content, _brand$content2, _structure$route2;
  var _ref$brands = _ref.brands,
    brands = _ref$brands === void 0 ? [] : _ref$brands,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    _ref$static = _ref["static"],
    staticProps = _ref$static === void 0 ? {} : _ref$static,
    _ref$structure = _ref.structure,
    structure = _ref$structure === void 0 ? {} : _ref$structure;
  var adsPath = staticProps.adsPath,
    channel = staticProps.channel,
    staticCustomerId = staticProps.customerId,
    screenName = staticProps.screenName,
    size = staticProps.size;
  var customerId = getCustomerId(staticCustomerId);
  var _useCookies = (0,esm/* useCookies */.fP)(),
    location = _useCookies.location;
  var _useState = (0,react.useState)(null),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    brand = _useState2[0],
    setBrand = _useState2[1];
  var adsPlacement = (0,react.useMemo)(function () {
    return "".concat(adsPath, "/").concat(brand == null ? void 0 : brand.slot);
  }, [adsPath, brand]);
  var adsEventsData = (0,react.useMemo)(function () {
    return {
      adsPath: adsPlacement,
      customerId: customerId,
      data: data,
      structure: structure
    };
  }, [adsPlacement, customerId, data, structure]);
  var eventData = {
    ad_type: 'sponsored_brands',
    customer_id: customerId,
    display: 'gallery',
    filters: structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.filters,
    list: brand == null ? void 0 : (_brand$content = brand.content) == null ? void 0 : _brand$content.headline,
    listPosition: 1,
    origin: "ads",
    pageName: structure == null ? void 0 : structure.name,
    showcase: {
      placeId: 'sponredbrandshowcase',
      title: brand == null ? void 0 : (_brand$content2 = brand.content) == null ? void 0 : _brand$content2.headline,
      type: 'carousel'
    },
    term: structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.term,
    type: 'marca-patrocinada'
  };
  var client = (0,build_esm.useClient)();
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _useAdsEvents = (0,build_esm.useAdsEvents)(adsEventsData),
    sendAdsClickEvents = _useAdsEvents.sendAdsClickEvents,
    sendAdsImpressionEvents = _useAdsEvents.sendAdsImpressionEvents;
  var _useState3 = (0,react.useState)(false),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var inViewConfig = (0,react.useMemo)(function () {
    return {
      threshold: 0.5,
      triggerOnce: false
    };
  }, []);
  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)(inViewConfig),
    _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var isVideo = (0,react.useMemo)(function () {
    var _brand$content$imageU, _brand$content3, _brand$content3$image;
    return (_brand$content$imageU = brand == null ? void 0 : (_brand$content3 = brand.content) == null ? void 0 : (_brand$content3$image = _brand$content3.imageUrl) == null ? void 0 : _brand$content3$image.includes('.m3u8')) !== null && _brand$content$imageU !== void 0 ? _brand$content$imageU : false;
  }, [brand]);
  var displayMode = (0,react.useMemo)(function () {
    if (isVideo) {
      return 'sponsored_brands-video';
    }
    return (brand == null ? void 0 : brand.template) === 'collection' ? 'sponsored_brands-logo' : 'sponsored_brands-imagem';
  }, [isVideo, brand]);
  var metadata = (0,react.useMemo)(function () {
    return {
      channelCode: channel,
      customerId: customerId,
      isLoyalty: false
    };
  }, [channel, customerId]);
  var promotionEventData = (0,react.useMemo)(function () {
    var _brand$content4, _brand$content5;
    if (!brand) return null;
    var brandBanner = {
      campaignId: brand == null ? void 0 : brand.campaignId,
      imageUrl: brand == null ? void 0 : (_brand$content4 = brand.content) == null ? void 0 : _brand$content4.imageUrl,
      redirectUrl: brand == null ? void 0 : (_brand$content5 = brand.content) == null ? void 0 : _brand$content5.redirectUrl,
      slot: brand == null ? void 0 : brand.slot,
      trackId: brand == null ? void 0 : brand.trackId
    };
    var eventDetails = {
      index: 0,
      position: 1,
      size: size || 'medium',
      slot: brandBanner == null ? void 0 : brandBanner.slot,
      vendorId: brand == null ? void 0 : brand.sellerId
    };
    return (0,esm/* buildGtmBannerEventData */.jv)(brandBanner, false, screenName, structure, eventDetails);
  }, [brand, size, screenName, structure, esm/* buildGtmBannerEventData */.jv]);
  var brandRedirectUrl = (0,react.useMemo)(function () {
    var _brand$content6;
    if (!(brand == null ? void 0 : (_brand$content6 = brand.content) == null ? void 0 : _brand$content6.redirectUrl)) return null;
    try {
      var _brand$content7;
      var url = new URL(brand == null ? void 0 : (_brand$content7 = brand.content) == null ? void 0 : _brand$content7.redirectUrl);
      url.searchParams.append('track_id', brand == null ? void 0 : brand.trackId);
      url.searchParams.append('internal_ad', 'true');
      return url.toString();
    } catch (error) {
      console.error('invalid URL', error);
      return null;
    }
  }, [brand]);
  var handleBrandClick = (0,react.useCallback)(function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee(e) {
      var eventName;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            eventName = 'promotion:brand:click';
            publish(eventName, promotionEventData);
            _context.next = 5;
            return sendAdsClickEvents([{
              adType: 'SPONSORED_BRAND',
              trackId: brand == null ? void 0 : brand.trackId
            }]);
          case 5:
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
          case 10:
            _context.prev = 10;
            if ((e == null ? void 0 : e.button) === 0) {
              (0,esm/* routePush */.dY)({
                path: brandRedirectUrl,
                spa: false
              });
            }
            return _context.finish(10);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7, 10, 13]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [brand, publish, sendAdsClickEvents, promotionEventData]);
  var handleBrandImpression = (0,react.useCallback)(function () {
    var eventName = 'promotion:brand:view';
    publish(eventName, promotionEventData);
    sendAdsImpressionEvents([{
      adType: 'SPONSORED_BRAND',
      trackId: brand == null ? void 0 : brand.trackId
    }]);
  }, [brand, publish, sendAdsImpressionEvents, promotionEventData]);
  var fetchAdsBrands = (0,react.useCallback)((0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee2() {
    var _responseData$adsBran, _yield$client$query, responseData, parsedBrand;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          if (!(!(brands == null ? void 0 : brands.length) || !metadata)) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          setLoading(true);
          _context2.next = 6;
          return client.query({
            fetchPolicy: 'no-cache',
            query: build_esm.AdsBrandsQuery,
            variables: {
              input: {
                brands: brands,
                metadata: metadata,
                zipcode: (location == null ? void 0 : location.zipCode) || ''
              }
            }
          });
        case 6:
          _yield$client$query = _context2.sent;
          responseData = _yield$client$query.data;
          parsedBrand = parseBrand((responseData == null ? void 0 : (_responseData$adsBran = responseData.adsBrands) == null ? void 0 : _responseData$adsBran.length) ? responseData == null ? void 0 : responseData.adsBrands[0] : null, structure);
          setBrand(parsedBrand);
          _context2.next = 15;
          break;
        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](0);
          console.error(_context2.t0);
        case 15:
          _context2.prev = 15;
          setLoading(false);
          return _context2.finish(15);
        case 18:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 12, 15, 18]]);
  })), [brands, metadata]);
  var handleProductClick = function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee3(e, product) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            publish('productlist:selectItem:click', (0,esm_extends/* default */.Z)({}, eventData, product, {
              displayMode: displayMode
            }));
            _context3.next = 4;
            return sendAdsClickEvents([{
              additionalAttribution: {
                id: product == null ? void 0 : product.id,
                type: 'product'
              },
              adType: 'SPONSORED_BRAND',
              position: (product == null ? void 0 : product.position) - 1,
              trackId: brand == null ? void 0 : brand.trackId
            }]);
          case 4:
            _context3.next = 9;
            break;
          case 6:
            _context3.prev = 6;
            _context3.t0 = _context3["catch"](0);
            console.error(_context3.t0);
          case 9:
            _context3.prev = 9;
            if ((e == null ? void 0 : e.button) === 0) {
              (0,esm/* routePush */.dY)({
                path: product.url,
                spa: false
              });
            }
            return _context3.finish(9);
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 6, 9, 12]]);
    }));
    return function handleProductClick(_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleProductView = (0,react.useCallback)(function (product) {
    if (product) {
      publish('product:viewItemList', (0,esm_extends/* default */.Z)({}, eventData, product, {
        displayMode: displayMode
      }));
    }
  }, [publish, displayMode, eventData]);
  (0,react.useEffect)(function () {
    var fetchData = function () {
      var _ref5 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return fetchAdsBrands();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function fetchData() {
        return _ref5.apply(this, arguments);
      };
    }();
    fetchData();
  }, [fetchAdsBrands]);
  return {
    adsPath: adsPlacement,
    brand: brand,
    handleBrandClick: handleBrandClick,
    handleBrandImpression: handleBrandImpression,
    handleProductClick: handleProductClick,
    handleProductView: handleProductView,
    inView: inView,
    isVideo: isVideo,
    loading: loading,
    ref: ref
  };
};
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrand.styles.js

var _templateObject;


var SectionBanner = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-direction: column;\n  align-items: center;\n"])));
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var stereo_ui_icons_build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/AdsBanner/AdsBanner.utils.js
var AdsBanner_utils = __webpack_require__(51653);
// EXTERNAL MODULE: ../modules/build/esm/hooks/useHlsVideo.js
var useHlsVideo = __webpack_require__(81692);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandBanner/AdsBrandVideo/styles.js

var styles_templateObject, _templateObject2, _templateObject3;

var MuteButton = styled_components_browser_esm["default"].button(styles_templateObject || (styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: 5%;\n  right: 2%;\n  background-color: rgba(0, 0, 0, 0.5);\n  border: none;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var StyledVideo = styled_components_browser_esm["default"].video(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  object-fit: cover;\n"])));
var VideoWrapper = styled_components_browser_esm["default"].div(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  display: block;\n  margin: auto;\n  width: ", ";\n  height: ", ";\n"])), function (_ref) {
  var width = _ref.width;
  return width || '100%';
}, function (_ref2) {
  var height = _ref2.height;
  return height || 'auto';
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandBanner/AdsBrandVideo/AdsBrandVideo.js









var AdsBrandVideo = function AdsBrandVideo(_ref) {
  var adsPath = _ref.adsPath,
    banner = _ref.banner,
    styles = _ref.styles,
    height = _ref.height,
    inView = _ref.inView,
    width = _ref.width;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var eventData = (0,react.useMemo)(function () {
    return {
      ad_type: 'sponsored_brands',
      creative_slot: adsPath,
      video_title: banner.videoTitle || '',
      video_url: banner.imageUrl
    };
  }, [banner.imageUrl, adsPath, banner.videoTitle]);
  var handleStart = (0,react.useCallback)(function (videoInfo) {
    publish('promotion:video:start', (0,esm_extends/* default */.Z)({}, eventData, (0,AdsBanner_utils/* buildVideoProgressionEventData */.HM)(videoInfo)));
  }, [publish, eventData]);
  var handleComplete = (0,react.useCallback)(function (videoInfo) {
    publish('promotion:video:complete', (0,esm_extends/* default */.Z)({}, eventData, (0,AdsBanner_utils/* buildVideoProgressionEventData */.HM)(videoInfo)));
  }, [publish, eventData]);
  var handleProgress = (0,react.useCallback)(function (videoInfo) {
    publish('promotion:video:progress', (0,esm_extends/* default */.Z)({}, eventData, (0,AdsBanner_utils/* buildVideoProgressionEventData */.HM)(videoInfo)));
  }, [publish, eventData]);
  var _useHlsVideo = (0,useHlsVideo/* useHlsVideo */.Y)({
      autoPlay: true,
      onComplete: handleComplete,
      onProgress: handleProgress,
      onStart: handleStart,
      videoUrl: banner.imageUrl
    }),
    videoRef = _useHlsVideo.videoRef,
    isMuted = _useHlsVideo.isMuted,
    controls = _useHlsVideo.controls;
  (0,react.useEffect)(function () {
    if (isLoaded) {
      if (inView) {
        controls.play();
      } else {
        controls.pause();
      }
    }
  }, [inView, isLoaded, controls]);
  var handleMuteToggle = function handleMuteToggle(e) {
    e.preventDefault();
    e.stopPropagation();
    controls.toggleMute();
  };
  return react.createElement(VideoWrapper, {
    width: width,
    height: height
  }, react.createElement(StyledVideo, {
    "aria-label": "Banner de ofertas do Magazine Luiza",
    ref: videoRef,
    height: height,
    width: width,
    playsInline: true,
    loop: true,
    style: (0,esm_extends/* default */.Z)({
      objectFit: 'fill'
    }, styles),
    onLoadedData: function onLoadedData() {
      return setIsLoaded(true);
    }
  }), isLoaded && react.createElement(MuteButton, {
    onClick: handleMuteToggle,
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    },
    "aria-label": isMuted ? 'Ativar som do vídeo' : 'Desativar som do vídeo',
    type: "button"
  }, isMuted ? react.createElement(stereo_ui_icons_build_esm/* Muted */.rO2, {
    width: 24,
    height: 24,
    color: "white"
  }) : react.createElement(stereo_ui_icons_build_esm/* Unmuted */.I5R, {
    width: 24,
    height: 24,
    color: "white"
  })));
};
 false ? 0 : void 0;
AdsBrandVideo.defaultProps = {
  height: '100%',
  inView: true,
  styles: {},
  width: '100%'
};
/* harmony default export */ var AdsBrandVideo_AdsBrandVideo = (AdsBrandVideo);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandBanner/AdsBrandVideo/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandBanner/AdsBrandBanner.js







var AdsBrandBanner = function AdsBrandBanner(_ref) {
  var banner = _ref.banner,
    isVideo = _ref.isVideo,
    handleBrandClick = _ref.handleBrandClick,
    adsPath = _ref.adsPath,
    width = _ref.width,
    height = _ref.height,
    styles = _ref.styles;
  var inViewConfig = (0,react.useMemo)(function () {
    return {
      threshold: 0.5,
      triggerOnce: false
    };
  }, []);
  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)(inViewConfig),
    _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var bannerRedirectUrl = (0,react.useMemo)(function () {
    if (!(banner == null ? void 0 : banner.redirectUrl)) return null;
    try {
      var url = new URL(banner.redirectUrl);
      return url.toString();
    } catch (error) {
      console.error('invalid URL', error);
      return null;
    }
  }, [banner]);
  return react.createElement(atoms/* Box */.xu, {
    ref: ref,
    style: {
      height: '100%'
    }
  }, react.createElement(atoms/* Link */.rU, {
    "data-testid": "ads-brand-banner",
    href: bannerRedirectUrl,
    style: {
      display: 'block',
      height: '100%'
    },
    onMouseDown: handleBrandClick,
    onClick: function onClick(e) {
      return e.preventDefault();
    }
  }, isVideo ? react.createElement(AdsBrandVideo_AdsBrandVideo, {
    adsPath: adsPath,
    banner: banner,
    height: height,
    inView: inView,
    width: width,
    styles: styles
  }) : react.createElement(atoms/* Image */.Ee, {
    src: banner.imageUrl,
    style: (0,esm_extends/* default */.Z)({}, styles, {
      height: height,
      objectFit: 'fill',
      width: width
    })
  })));
};
AdsBrandBanner.defaultProps = {
  adsPath: '',
  banner: {},
  handleBrandClick: function handleBrandClick() {},
  height: 0,
  isVideo: false,
  styles: {},
  width: 0
};
 false ? 0 : void 0;
AdsBrandBanner.ssr = true;
/* harmony default export */ var AdsBrandBanner_AdsBrandBanner = (AdsBrandBanner);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandBanner/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/utils.js
var utils = __webpack_require__(77833);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandDesktop/styles.js

var AdsBrandDesktop_styles_templateObject;



var Section = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(AdsBrandDesktop_styles_templateObject || (AdsBrandDesktop_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  height: 289px;\n  border-radius: 8px;\n  background: ", ";\n  align-items: center;\n  flex-direction: row;\n"])), function (props) {
  return (0,utils/* getBackgroundColor */.dF)('white')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandDesktop/AdsBrandSellerInfo/styles.js

var AdsBrandSellerInfo_styles_templateObject;


var SectionSeller = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(AdsBrandSellerInfo_styles_templateObject || (AdsBrandSellerInfo_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 12px;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandDesktop/AdsBrandSellerInfo/AdsBrandSellerInfo.js





var AdsBrandSellerInfo = function AdsBrandSellerInfo(_ref) {
  var logo = _ref.logo,
    headline = _ref.headline,
    subtitle = _ref.subtitle,
    buttonTitle = _ref.buttonTitle,
    redirectUrl = _ref.redirectUrl,
    handleBrandClick = _ref.handleBrandClick,
    template = _ref.template;
  return react.createElement(SectionSeller, {
    "data-testid": "section-seller",
    style: {
      margin: template === 'creative' ? '0 0 0 14px' : '0 0 0 22px',
      maxHeight: '254px',
      width: '174px'
    }
  }, react.createElement(atoms/* Image */.Ee, {
    src: logo,
    style: {
      maxHeight: 100,
      maxWidth: 174
    }
  }), react.createElement(atoms/* Flex */.kC, {
    width: 174,
    flexDirection: "column",
    gap: 1
  }, headline && react.createElement(atoms/* Text */.xv, {
    "data-testid": "headline",
    color: "text.base",
    fontWeight: "600",
    fontSize: 2
  }, headline), subtitle && react.createElement(atoms/* Text */.xv, {
    "data-testid": "subtitle",
    color: "text.base",
    fontWeight: "200",
    lineHeight: 1.25,
    fontSize: 2
  }, subtitle)), react.createElement(atoms/* Flex */.kC, {
    gap: 1
  }, buttonTitle && redirectUrl && react.createElement(react.Fragment, null, react.createElement(atoms/* Link */.rU, {
    "data-testid": "link",
    href: redirectUrl,
    color: "text.primary",
    fontWeight: "600",
    fontSize: 2,
    onMouseDown: handleBrandClick,
    onClick: function onClick(e) {
      return e.preventDefault();
    }
  }, buttonTitle), react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
    color: "text.primary",
    name: "ChevronRight",
    "data-testid": "icon"
  }))));
};
AdsBrandSellerInfo.defaultProps = {
  buttonTitle: null,
  handleBrandClick: function handleBrandClick() {},
  headline: null,
  logo: null,
  redirectUrl: '#',
  styles: {},
  subtitle: null,
  template: ''
};
 false ? 0 : void 0;
AdsBrandSellerInfo.ssr = true;
/* harmony default export */ var AdsBrandSellerInfo_AdsBrandSellerInfo = (AdsBrandSellerInfo);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandDesktop/AdsBrandSellerInfo/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCarousel/index.js + 1 modules
var ProductCarousel = __webpack_require__(4720);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/index.js + 18 modules
var ProductCard = __webpack_require__(47719);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandDesktop/AdsBrandProducts/AdsBrandProducts.js






var AdsBrandProducts = function AdsBrandProducts(_ref) {
  var campaignId = _ref.campaignId,
    products = _ref.products,
    template = _ref.template,
    handleProductView = _ref.handleProductView,
    handleProductClick = _ref.handleProductClick;
  var carouselConfig = {
    auto: false,
    enableHover: false,
    gutter: 0,
    showArrowControls: true,
    showControls: false,
    showPartial: false,
    showPartialNextSlide: true,
    slidesPerView: template === 'creative' ? 1 : 3
  };
  var carouselWidth = template === 'creative' ? 310 : 770;
  var parsedProducts = products.map(function (product, index) {
    return {
      allowEmptyRatting: true,
      campaignId: campaignId,
      category: product == null ? void 0 : product.category,
      id: product == null ? void 0 : product.id,
      image: product == null ? void 0 : product.image,
      path: '/',
      position: index + 1,
      price: product == null ? void 0 : product.price,
      seller: product == null ? void 0 : product.seller,
      subcategory: product == null ? void 0 : product.subcategory,
      title: product == null ? void 0 : product.title,
      url: product == null ? void 0 : product.path
    };
  });
  var showCarousel = template === 'collection' && parsedProducts.length >= 4 || template === 'creative' && parsedProducts.length >= 2;
  return react.createElement(atoms/* Flex */.kC, {
    "data-testid": "brand-products",
    width: "100%",
    justifyContent: "center"
  }, showCarousel ? react.createElement(atoms/* Flex */.kC, {
    width: carouselWidth,
    gap: 1,
    flexDirection: "column"
  }, react.createElement(ProductCarousel/* default */.Z, (0,esm_extends/* default */.Z)({
    "data-testid": "product-carousel",
    products: parsedProducts,
    displayMode: "sponsoredBrandMedium",
    fullHeight: false,
    onProductView: handleProductView,
    onMouseDown: handleProductClick,
    onClick: function onClick(e) {
      return e.preventDefault();
    },
    showDiscount: false,
    showDiscountOnlyCashInfo: false
  }, carouselConfig)), react.createElement(atoms/* Text */.xv, {
    "data-testid": "text-carousel",
    color: "text.scratched",
    fontWeight: "400",
    fontSize: "12px",
    style: {
      alignSelf: 'flex-end',
      marginRight: '44px'
    }
  }, "Patrocinado")) : react.createElement(atoms/* Flex */.kC, {
    width: "fit-content",
    alignItems: "center",
    flexDirection: "column",
    gap: 1
  }, react.createElement(atoms/* Flex */.kC, {
    gap: 2
  }, parsedProducts.map(function (product) {
    return react.createElement("div", {
      "data-testid": "product-card-list",
      key: product.id,
      style: {
        width: '199px'
      }
    }, react.createElement(ProductCard/* default */.Z, (0,esm_extends/* default */.Z)({
      "data-testid": "product-card",
      onView: handleProductView,
      onMouseDown: handleProductClick,
      onClick: function onClick(e) {
        return e.preventDefault();
      },
      image: product.image,
      installment: product.installment,
      price: product.price,
      title: product.title,
      url: product.url,
      showDiscount: false,
      showDiscountOnlyCashInfo: false,
      displayMode: "sponsoredBrandMedium"
    }, product)));
  })), react.createElement(atoms/* Text */.xv, {
    "data-testid": "text-product-card",
    color: "text.scratched",
    fontWeight: "400",
    fontSize: "12px",
    style: {
      alignSelf: 'flex-end'
    }
  }, "Patrocinado")));
};
AdsBrandProducts.defaultProps = {
  campaignId: '',
  handleProductClick: function handleProductClick() {},
  handleProductView: function handleProductView() {},
  products: [],
  template: null
};
 false ? 0 : void 0;
AdsBrandProducts.ssr = true;
/* harmony default export */ var AdsBrandProducts_AdsBrandProducts = (AdsBrandProducts);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandDesktop/AdsBrandProducts/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandDesktop/AdsBrandDesktop.js








var AdsBrandDesktop = function AdsBrandDesktop(_ref) {
  var _brand$content3, _brand$content4, _brand$content5, _brand$content6, _brand$content7;
  var adsPath = _ref.adsPath,
    brand = _ref.brand,
    handleBrandClick = _ref.handleBrandClick,
    handleBrandImpression = _ref.handleBrandImpression,
    handleProductClick = _ref.handleProductClick,
    handleProductView = _ref.handleProductView,
    marginTop = _ref.marginTop,
    isVideo = _ref.isVideo;
  var brandRedirectUrl = (0,react.useMemo)(function () {
    var _brand$content;
    if (!(brand == null ? void 0 : (_brand$content = brand.content) == null ? void 0 : _brand$content.redirectUrl)) return null;
    try {
      var _brand$content2;
      var url = new URL(brand == null ? void 0 : (_brand$content2 = brand.content) == null ? void 0 : _brand$content2.redirectUrl);
      url.searchParams.append('track_id', brand == null ? void 0 : brand.trackId);
      url.searchParams.append('internal_ad', 'true');
      return url.toString();
    } catch (error) {
      console.error('invalid URL', error);
      return null;
    }
  }, [brand]);
  var banner = {
    imageUrl: brand == null ? void 0 : (_brand$content3 = brand.content) == null ? void 0 : _brand$content3.imageUrl,
    redirectUrl: brandRedirectUrl
  };
  var inViewConfig = (0,react.useMemo)(function () {
    return {
      threshold: 0.5,
      triggerOnce: true
    };
  }, []);
  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)(inViewConfig),
    _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  (0,react.useEffect)(function () {
    if (inView) {
      handleBrandImpression();
    }
  }, [inView]);
  return brand && react.createElement(Section, {
    ref: ref,
    marginTop: marginTop,
    "data-testid": "ads-brand-desktop"
  }, react.createElement("span", {
    "data-testid": "ads-banner_screenshot",
    "ads-screenshot-id": "ads-banner_".concat(brand == null ? void 0 : brand.slot, "_").concat(brand == null ? void 0 : brand.campaignId)
  }), (brand == null ? void 0 : brand.template) === 'creative' && react.createElement(AdsBrandBanner_AdsBrandBanner, {
    adsPath: adsPath,
    banner: banner,
    isVideo: isVideo,
    handleBrandClick: handleBrandClick,
    width: 464,
    height: 289,
    styles: {
      borderBottomLeftRadius: 8,
      borderTopLeftRadius: 8
    }
  }), react.createElement(AdsBrandSellerInfo_AdsBrandSellerInfo, {
    buttonTitle: brand == null ? void 0 : (_brand$content4 = brand.content) == null ? void 0 : _brand$content4.buttonTitle,
    handleBrandClick: handleBrandClick,
    redirectUrl: brandRedirectUrl,
    headline: brand == null ? void 0 : (_brand$content5 = brand.content) == null ? void 0 : _brand$content5.headline,
    logo: brand == null ? void 0 : (_brand$content6 = brand.content) == null ? void 0 : _brand$content6.logo,
    subtitle: brand == null ? void 0 : (_brand$content7 = brand.content) == null ? void 0 : _brand$content7.subtitle,
    template: brand == null ? void 0 : brand.template
  }), react.createElement(AdsBrandProducts_AdsBrandProducts, {
    campaignId: brand == null ? void 0 : brand.campaignId,
    products: brand == null ? void 0 : brand.products,
    template: brand == null ? void 0 : brand.template,
    handleProductClick: handleProductClick,
    handleProductView: handleProductView
  }));
};
AdsBrandDesktop.defaultProps = {
  adsPath: '',
  brand: {
    content: {
      buttonTitle: '',
      headline: '',
      imageUrl: '',
      logo: '',
      redirectUrl: '',
      subtitle: ''
    },
    products: [],
    template: '',
    trackId: ''
  },
  handleBrandClick: function handleBrandClick() {},
  handleBrandImpression: function handleBrandImpression() {},
  handleProductClick: function handleProductClick() {},
  handleProductView: function handleProductView() {},
  isVideo: false,
  marginTop: '0px'
};
 false ? 0 : void 0;
AdsBrandDesktop.ssr = true;
/* harmony default export */ var AdsBrandDesktop_AdsBrandDesktop = (AdsBrandDesktop);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandDesktop/index.js

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandsMobile/AdsBrandsMobile.styles.js


var AdsBrandsMobile_styles_templateObject, AdsBrandsMobile_styles_templateObject2;



var Container = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(AdsBrandsMobile_styles_templateObject || (AdsBrandsMobile_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var FlexList = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(AdsBrandsMobile_styles_templateObject2 || (AdsBrandsMobile_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  gap: 8px;\n  overflow-x: scroll;\n\n  & > a:hover,\n  & > a:focus,\n  & > a:active {\n    border: 1px solid #d3dadd;\n  }\n\n  & > * {\n    min-width: 100px;\n\n    & h2 {\n      color: #697277;\n      margin-top: 4px;\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandsMobile/AdsBrandsMobile.js












var AdsBrandsMobile = function AdsBrandsMobile(_ref) {
  var _brand$content3, _brand$content4, _brand$content5, _brand$content6, _brand$content7, _brand$content8;
  var adsPath = _ref.adsPath,
    brand = _ref.brand,
    handleBrandClick = _ref.handleBrandClick,
    handleBrandImpression = _ref.handleBrandImpression,
    isVideo = _ref.isVideo,
    handleProductClick = _ref.handleProductClick,
    handleProductView = _ref.handleProductView,
    marginBottom = _ref.marginBottom,
    marginTop = _ref.marginTop;
  var inViewConfig = (0,react.useMemo)(function () {
    return {
      threshold: 0.5,
      triggerOnce: true
    };
  }, []);
  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)(inViewConfig),
    _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  (0,react.useEffect)(function () {
    if (inView) {
      handleBrandImpression();
    }
  }, [inView]);
  var _useState = (0,react.useState)([]),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    parseAdsProducts = _useState2[0],
    setParseAdsProducts = _useState2[1];
  var brandRedirectUrl = (0,react.useMemo)(function () {
    var _brand$content;
    if (!(brand == null ? void 0 : (_brand$content = brand.content) == null ? void 0 : _brand$content.redirectUrl)) return null;
    try {
      var _brand$content2;
      var url = new URL(brand == null ? void 0 : (_brand$content2 = brand.content) == null ? void 0 : _brand$content2.redirectUrl);
      url.searchParams.append('track_id', brand == null ? void 0 : brand.trackId);
      url.searchParams.append('internal_ad', 'true');
      return url.toString();
    } catch (error) {
      console.error('invalid URL', error);
      return null;
    }
  }, [brand]);
  var banner = {
    imageUrl: brand == null ? void 0 : (_brand$content3 = brand.content) == null ? void 0 : _brand$content3.imageUrl,
    redirectUrl: brandRedirectUrl
  };
  (0,react.useEffect)(function () {
    if (brand == null ? void 0 : brand.products.length) {
      var _brand$products;
      brand == null ? void 0 : (_brand$products = brand.products) == null ? void 0 : _brand$products.forEach(function (product, index) {
        setParseAdsProducts(function (prev) {
          return [].concat((0,toConsumableArray/* default */.Z)(prev), [{
            allowEmptyRatting: true,
            campaignId: brand.campaignId,
            category: product.category,
            hidePrice: true,
            hidePriceMode: 'hide',
            id: product.id,
            image: product == null ? void 0 : product.image,
            installment: product == null ? void 0 : product.installment,
            path: '/',
            position: index + 1,
            price: product == null ? void 0 : product.price,
            rating: product == null ? void 0 : product.rating,
            seller: product.seller,
            subcategory: product.subcategory,
            title: product == null ? void 0 : product.title,
            url: product == null ? void 0 : product.path
          }]);
        });
      });
    }
  }, [brand]);
  if (!brand) return null;
  return react.createElement(react.Fragment, null, react.createElement(atoms/* Box */.xu, {
    ref: ref,
    bg: "white",
    width: "100%",
    maxHeight: "396px",
    padding: "8px",
    borderRadius: "8px",
    "data-testid": "ads-sponsored-brands",
    marginTop: marginTop,
    marginBottom: marginBottom
  }, react.createElement("span", {
    "data-testid": "ads-banner_screenshot",
    "ads-screenshot-id": "ads-banner_".concat(brand == null ? void 0 : brand.slot, "_").concat(brand == null ? void 0 : brand.campaignId)
  }), react.createElement(atoms/* Flex */.kC, {
    flexDirection: "column",
    gap: "8px"
  }, react.createElement(atoms/* Flex */.kC, null, react.createElement(atoms/* Text */.xv, {
    color: "text.scratched",
    fontSize: "10px"
  }, "Patrocinado")), react.createElement(atoms/* Flex */.kC, {
    alignItems: "center",
    columnGap: 2
  }, react.createElement(atoms/* Image */.Ee, {
    lazy: true,
    cover: true,
    src: brand == null ? void 0 : (_brand$content4 = brand.content) == null ? void 0 : _brand$content4.logo,
    style: {
      height: '27px',
      width: '85px'
    }
  }), react.createElement(atoms/* Flex */.kC, {
    flexDirection: "column",
    rowGap: 1
  }, react.createElement(atoms/* Text */.xv, {
    fontSize: "14px",
    fontWeight: "bold"
  }, brand == null ? void 0 : (_brand$content5 = brand.content) == null ? void 0 : _brand$content5.headline), react.createElement(atoms/* Text */.xv, {
    fontSize: "14px"
  }, brand == null ? void 0 : (_brand$content6 = brand.content) == null ? void 0 : _brand$content6.subtitle), react.createElement(atoms/* Link */.rU, {
    onMouseDown: handleBrandClick,
    onClick: function onClick(e) {
      return e.preventDefault();
    },
    "data-testid": "blog-ecommerce-link",
    href: brandRedirectUrl
  }, react.createElement(atoms/* Flex */.kC, {
    alignItems: "center",
    justifyContent: "center",
    columnGap: 2
  }, react.createElement(atoms/* Text */.xv, {
    color: "primary.dark",
    fontSize: "14px",
    fontWeight: "bold"
  }, (brand == null ? void 0 : (_brand$content7 = brand.content) == null ? void 0 : _brand$content7.buttonTitle) || 'Ver mais'), react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
    color: "primary.dark",
    name: "ChevronRight",
    height: "14px",
    width: "14px"
  }))))), (brand == null ? void 0 : (_brand$content8 = brand.content) == null ? void 0 : _brand$content8.imageUrl) && react.createElement(AdsBrandBanner_AdsBrandBanner, {
    adsPath: adsPath,
    banner: banner,
    isVideo: isVideo,
    handleBrandClick: handleBrandClick,
    width: "100%",
    height: 176,
    styles: {
      borderRadius: 8
    }
  }), (parseAdsProducts == null ? void 0 : parseAdsProducts.length) > 0 && react.createElement(FlexList, null, parseAdsProducts.map(function (product) {
    return react.createElement(ProductCard/* default */.Z, (0,esm_extends/* default */.Z)({
      key: product.id,
      onView: handleProductView,
      onMouseDown: handleProductClick,
      onClick: function onClick(e) {
        return e.preventDefault();
      },
      fullHeight: true,
      showDiscount: false,
      showDiscountOnlyCashInfo: false,
      hideOriginalPrice: true,
      showRating: false,
      displayMode: "sponsoredBrand"
    }, product));
  })))));
};
AdsBrandsMobile.defaultProps = {
  adsPath: '',
  brand: {
    campaignId: '',
    content: {
      buttonTitle: '',
      headline: '',
      imageUrl: '',
      logo: '',
      redirectUrl: '',
      subtitle: ''
    },
    products: [],
    template: '',
    trackId: ''
  },
  handleBrandClick: function handleBrandClick() {},
  handleBrandImpression: function handleBrandImpression() {},
  handleProductClick: function handleProductClick() {},
  handleProductView: function handleProductView() {},
  isVideo: false,
  marginBottom: '0px',
  marginTop: '0px'
};
 false ? 0 : void 0;
AdsBrandsMobile.ssr = true;
/* harmony default export */ var AdsBrandsMobile_AdsBrandsMobile = ((0,withLayoutProps/* default */.Z)(AdsBrandsMobile));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrandsMobile/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/AdsBrand.js








var AdsBrand = function AdsBrand(_ref) {
  var children = _ref.children,
    data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure;
  var _staticProps$marginTo = staticProps.marginTop,
    marginTop = _staticProps$marginTo === void 0 ? '0px' : _staticProps$marginTo,
    _staticProps$marginBo = staticProps.marginBottom,
    marginBottom = _staticProps$marginBo === void 0 ? '0px' : _staticProps$marginBo;
  var memoizedStaticProps = (0,react.useMemo)(function () {
    return staticProps;
  }, [staticProps]);
  var _useAdsBrands = useAdsBrands({
      brands: memoizedStaticProps.brands,
      data: data,
      "static": memoizedStaticProps,
      structure: structure
    }),
    adsPath = _useAdsBrands.adsPath,
    loading = _useAdsBrands.loading,
    brand = _useAdsBrands.brand,
    handleBrandClick = _useAdsBrands.handleBrandClick,
    handleBrandImpression = _useAdsBrands.handleBrandImpression,
    handleProductClick = _useAdsBrands.handleProductClick,
    handleProductView = _useAdsBrands.handleProductView,
    isVideo = _useAdsBrands.isVideo;
  var _useAdsProvider = (0,contexts/* useAdsProvider */.J)(),
    isBannerLoading = _useAdsProvider.isLoading;
  var shouldRenderComponent = (0,react.useMemo)(function () {
    return !loading && !isBannerLoading;
  }, [loading, isBannerLoading]);
  var shouldShowBanner = (0,react.useMemo)(function () {
    return !brand;
  }, [brand]);
  return shouldRenderComponent ? react.createElement(react.Fragment, null, shouldShowBanner ? react.createElement(SectionBanner, null, children) : staticProps.channel === 'MSITE' ? react.createElement(AdsBrandsMobile_AdsBrandsMobile, {
    marginTop: marginTop,
    marginBottom: marginBottom,
    adsPath: adsPath,
    brand: brand,
    handleBrandClick: handleBrandClick,
    handleBrandImpression: handleBrandImpression,
    handleProductClick: handleProductClick,
    handleProductView: handleProductView,
    isVideo: isVideo
  }) : react.createElement(AdsBrandDesktop_AdsBrandDesktop, {
    marginTop: marginTop,
    adsPath: adsPath,
    brand: brand,
    handleBrandClick: handleBrandClick,
    handleBrandImpression: handleBrandImpression,
    handleProductClick: handleProductClick,
    handleProductView: handleProductView,
    isVideo: isVideo
  })) : null;
};
AdsBrand.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
 false ? 0 : void 0;
AdsBrand.ssr = true;
/* harmony default export */ var AdsBrand_AdsBrand = ((0,withLayoutProps/* default */.Z)(AdsBrand));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsBrand/index.js



/***/ }),

/***/ 44741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ AdsCarousel_AdsCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../modules/build/esm/contexts/index.js + 3 modules
var contexts = __webpack_require__(43812);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/AdsBanner/index.js + 5 modules
var AdsBanner = __webpack_require__(10369);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/AdsBannerSkeleton/index.js + 1 modules
var AdsBannerSkeleton = __webpack_require__(81126);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsCarousel/AdsCarousel.js



var _excluded = ["aspectRatio", "bannerArray", "position", "screenName", "slots", "hasPlaceholder", "minWidth", "minHeight"];








var AdsCarousel = function AdsCarousel(_ref) {
  var data = _ref.data,
    _ref$static = _ref["static"],
    _ref$static$aspectRat = _ref$static.aspectRatio,
    aspectRatio = _ref$static$aspectRat === void 0 ? '16/9' : _ref$static$aspectRat,
    bannerArray = _ref$static.bannerArray,
    position = _ref$static.position,
    screenName = _ref$static.screenName,
    slots = _ref$static.slots,
    _ref$static$hasPlaceh = _ref$static.hasPlaceholder,
    hasPlaceholder = _ref$static$hasPlaceh === void 0 ? false : _ref$static$hasPlaceh,
    minWidth = _ref$static.minWidth,
    minHeight = _ref$static.minHeight,
    staticProps = (0,objectWithoutProperties/* default */.Z)(_ref$static, _excluded),
    structure = _ref.structure;
  var _useAdsProvider = (0,contexts/* useAdsProvider */.J)(),
    ads = _useAdsProvider.ads,
    getBannerBySlot = _useAdsProvider.getBannerBySlot,
    isBannersLoading = _useAdsProvider.isLoading;
  var _useState = (0,react.useState)([]),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    banners = _useState2[0],
    setBanners = _useState2[1];
  var _useCookies = (0,esm/* useCookies */.fP)(),
    _useCookies$customerI = _useCookies.customerId,
    customerId = _useCookies$customerI === void 0 ? '' : _useCookies$customerI;
  var buildBannerMapper = function buildBannerMapper() {
    return function (banner) {
      return {
        data: data,
        "static": (0,esm_extends/* default */.Z)({}, banner, {
          customerId: customerId,
          isBannerCarousel: true,
          position: position,
          screenName: screenName
        }),
        structure: structure
      };
    };
  };
  (0,react.useEffect)(function () {
    if (bannerArray) {
      var mapper = buildBannerMapper();
      var mappedBanners = bannerArray.map(mapper);
      setBanners(mappedBanners);
    }
  }, [bannerArray]);
  (0,react.useEffect)(function () {
    if (slots) {
      var bannersBySlot = slots.map(function (item) {
        var mappedBannersBySlot = getBannerBySlot(item.slot);
        return mappedBannersBySlot == null ? void 0 : mappedBannersBySlot.map(function (banner) {
          return (0,esm_extends/* default */.Z)({}, banner, item);
        });
      });
      var mappedBanners = bannersBySlot.map(function (bannerArr) {
        if (!bannerArr) return [];
        var mapper = buildBannerMapper();
        return bannerArr.map(mapper);
      });
      setBanners(mappedBanners.flat());
    }
  }, [ads, slots]);
  return react.createElement(react.Fragment, null, !!(banners == null ? void 0 : banners.length) && !isBannersLoading && react.createElement(molecules/* Carousel */.lr, (0,esm_extends/* default */.Z)({
    bg: "background.darker",
    height: "fit-content",
    width: "100%",
    overflow: "hidden"
  }, staticProps), banners.map(function (item, index) {
    return react.createElement(AdsBanner/* default */.ZP, {
      data: item.data,
      "static": (0,esm_extends/* default */.Z)({}, item["static"], {
        aspectRatio: aspectRatio,
        index: index
      }),
      structure: item.structure,
      key: item["static"].trackId
    });
  })), react.createElement(AdsBannerSkeleton/* default */.Z, {
    height: minHeight,
    isVisible: isBannersLoading && hasPlaceholder,
    width: minWidth
  }));
};
AdsCarousel.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
 false ? 0 : void 0;
/* harmony default export */ var AdsCarousel_AdsCarousel = ((0,withLayoutProps/* default */.Z)(AdsCarousel));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsCarousel/index.js


/***/ }),

/***/ 65922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AdsShowcase_AdsShowcase; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/index.js + 10 modules
var Showcase = __webpack_require__(75335);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/contexts/index.js + 3 modules
var contexts = __webpack_require__(43812);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var utils_build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/commons/constants.js
var constants = __webpack_require__(88338);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsShowcase/parseAdsProducts.js



var ensureEvenLength = function ensureEvenLength(productArr, structure) {
  var _structure$device;
  if ((structure == null ? void 0 : (_structure$device = structure.device) == null ? void 0 : _structure$device.toLowerCase().trim()) !== 'mobile') return productArr;
  if (productArr.length % 2 !== 0 && productArr.length > 0) {
    productArr.pop();
  }
  return productArr;
};
var getUrlProductWithAdsParams = function getUrlProductWithAdsParams(path, structure) {
  var url = new URL(path, structure.config.domain);
  url.searchParams.set(constants/* ADS */.GF, constants/* SPONSORED */.B6);
  return (0,utils_build_esm/* parsePath */.cP)(url.pathname.concat(url.search));
};
var parseAdsProducts = function parseAdsProducts(adsResponse, structure) {
  if (!adsResponse || !Array.isArray(adsResponse)) return undefined;
  var parsedProducts = adsResponse == null ? void 0 : adsResponse.map(function (product, index) {
    var _product$price, _product$shippingTag, _product$shippingTag2, _product$shippingTag3, _product$shippingTag4;
    if (!Object.values(product).length || !product.title) return null;
    return (0,esm_extends/* default */.Z)({}, product, {
      available: true,
      brand: product.brand,
      campaignId: product.campaignId,
      category: {
        name: product.category
      },
      id: product.id,
      image: product.image,
      offerTags: product.offerTags,
      path: '/',
      position: index + 1,
      price: (0,esm_extends/* default */.Z)({}, product.price, {
        paymentMethodDescription: product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.paymentMethodDescription
      }),
      rating: product.rating,
      seller: {
        id: product.seller.id
      },
      shippingTag: {
        complement: (_product$shippingTag = product.shippingTag) == null ? void 0 : _product$shippingTag.complement,
        cost: (_product$shippingTag2 = product.shippingTag) == null ? void 0 : _product$shippingTag2.cost,
        source: (_product$shippingTag3 = product.shippingTag) == null ? void 0 : _product$shippingTag3.source,
        time: (_product$shippingTag4 = product.shippingTag) == null ? void 0 : _product$shippingTag4.time
      },
      subcategory: {
        name: product.subcategory.name
      },
      title: product.title,
      trackId: product.trackId,
      url: getUrlProductWithAdsParams(product == null ? void 0 : product.path, structure)
    });
  }).filter(Boolean);
  return ensureEvenLength(parsedProducts, structure);
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsShowcase/utils.js
var buildEventData = function buildEventData(_ref) {
  var _structure$route, _showcase$config, _showcase$config2, _structure$route2;
  var customerId = _ref.customerId,
    structure = _ref.structure,
    showcase = _ref.showcase,
    placement = _ref.placement,
    exhibition = _ref.exhibition;
  return {
    customer_id: customerId,
    display: 'gallery',
    filters: structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.filters,
    list: showcase == null ? void 0 : (_showcase$config = showcase.config) == null ? void 0 : _showcase$config.title,
    origin: "ads:".concat(placement),
    pageName: structure == null ? void 0 : structure.name,
    showcase: {
      placeId: placement,
      title: showcase == null ? void 0 : (_showcase$config2 = showcase.config) == null ? void 0 : _showcase$config2.title,
      type: exhibition
    },
    term: structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.term,
    type: 'recomendacao'
  };
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsShowcase/AdsShowcase.js












var AdsShowcase = function AdsShowcase(_ref) {
  var staticProps = _ref["static"],
    structure = _ref.structure,
    data = _ref.data;
  var _staticProps$carousel = staticProps.carouselConfig,
    carouselConfig = _staticProps$carousel === void 0 ? {} : _staticProps$carousel,
    slot = staticProps.slot,
    _staticProps$showcase = staticProps.showcase,
    showcase = _staticProps$showcase === void 0 ? {} : _staticProps$showcase,
    exhibition = staticProps.exhibition,
    titleAs = staticProps.titleAs,
    productTitleAs = staticProps.productTitleAs,
    jsonLD = staticProps.jsonLD,
    adsPath = staticProps.adsPath,
    placement = staticProps.placement,
    showInCashLabel = staticProps.showInCashLabel,
    showDiscount = staticProps.showDiscount,
    showDiscountOnlyCashInfo = staticProps.showDiscountOnlyCashInfo,
    inCashDescription = staticProps.inCashDescription;
  var ref = (0,react.useRef)(null);
  var _useAdsProvider = (0,contexts/* useAdsProvider */.J)(),
    ads = _useAdsProvider.ads,
    getProductsBySlot = _useAdsProvider.getProductsBySlot;
  var _useState = (0,react.useState)([]),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    parsedProducts = _useState2[0],
    setParsedProducts = _useState2[1];
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _useCookies = (0,utils_build_esm/* useCookies */.fP)(),
    _useCookies$customerI = _useCookies.customerId,
    customerId = _useCookies$customerI === void 0 ? '' : _useCookies$customerI;
  var eventData = buildEventData({
    customerId: customerId,
    exhibition: exhibition,
    placement: placement,
    showcase: showcase,
    structure: structure
  });
  var _useAdsEvents = (0,esm.useAdsEvents)({
      adsPath: adsPath,
      customerId: customerId,
      data: data,
      structure: structure
    }),
    sendAdsImpressionEvents = _useAdsEvents.sendAdsImpressionEvents,
    sendAdsClickEvents = _useAdsEvents.sendAdsClickEvents;
  var buildItemEventData = function buildItemEventData(product) {
    return (0,esm_extends/* default */.Z)({}, eventData, product, {
      showcase: (0,esm_extends/* default */.Z)({}, eventData.showcase, {
        id: product == null ? void 0 : product.campaignId
      })
    });
  };
  var handleProductClick = function handleProductClick(e, product) {
    publish('productlist:selectItem:click', buildItemEventData(product));
    sendAdsClickEvents([(0,esm_extends/* default */.Z)({}, product, {
      adType: 'SPONSORED_PRODUCT',
      position: (product == null ? void 0 : product.position) - 1
    })]);
  };
  var handleProductView = function handleProductView(product) {
    publish('product:viewItemList', buildItemEventData(product));
    sendAdsImpressionEvents([(0,esm_extends/* default */.Z)({}, product, {
      adType: 'SPONSORED_PRODUCT',
      position: (product == null ? void 0 : product.position) - 1
    })]);
  };
  (0,react.useEffect)(function () {
    if (ads && Object.keys((ads == null ? void 0 : ads.products) || {}).length > 0) {
      var products = getProductsBySlot(slot);
      setParsedProducts(parseAdsProducts(products, structure));
    } else {
      setParsedProducts([]);
    }
  }, [ads]);
  return react.createElement(react.Fragment, null, !!(parsedProducts == null ? void 0 : parsedProducts.length) && react.createElement(Showcase/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: ref,
    key: "ads-showcase-1",
    exhibition: exhibition,
    data: (0,esm_extends/* default */.Z)({}, showcase == null ? void 0 : showcase.config, {
      products: parsedProducts
    }),
    jsonLD: jsonLD,
    titleAs: titleAs,
    productTitleAs: productTitleAs,
    showInCashInfo: showInCashLabel,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    showSponsoredSubTitle: true,
    onMouseDown: handleProductClick,
    onProductView: handleProductView,
    inCashDescription: inCashDescription
  }, carouselConfig)));
};
 false ? 0 : void 0;
AdsShowcase.defaultProps = {
  data: {},
  "static": {
    exhibition: 'carousel',
    limit: 5
  },
  structure: {}
};
AdsShowcase.ssr = true;
/* harmony default export */ var AdsShowcase_AdsShowcase = ((0,withLayoutProps/* default */.Z)(AdsShowcase));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AdsShowcase/index.js


/***/ }),

/***/ 66176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ AlertText_AlertText; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/AlertText/index.js + 2 modules
var molecules_AlertText = __webpack_require__(52337);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AlertText/AlertText.js



var _excluded = ["message", "intent", "linkText"];






function getPublishMessage(messages, publish, linkText) {
  if (Array.isArray(messages)) {
    return messages.map(function (message) {
      if (message.includes('publish: ')) {
        var _message$split = message.split('publish: '),
          _message$split2 = (0,slicedToArray/* default */.Z)(_message$split, 2),
          publishMsg = _message$split2[1];
        return (react.createElement(Link/* default */.Z, {
            as: "span",
            color: "inherit",
            "data-testid": "link-knowmore",
            onClick: function onClick() {
              return publish(publishMsg);
            }
          }, linkText)
        );
      }
      return message;
    });
  }
  return messages;
}
var AlertText = function AlertText(_ref) {
  var _ref$static = _ref["static"],
    message = _ref$static.message,
    intent = _ref$static.intent,
    linkText = _ref$static.linkText,
    layout = (0,objectWithoutProperties/* default */.Z)(_ref$static, _excluded);
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var alerts = typeof message === 'string' ? [message] : message;
  return alerts && alerts.map(function (value) {
    var values = getPublishMessage(value, publish, linkText);
    return react.createElement(Box/* default */.Z, (0,esm_extends/* default */.Z)({
      key: "alert-".concat(value)
    }, layout, {
      "data-testid": "alert"
    }), react.createElement(molecules_AlertText/* default */.Z, {
      message: values,
      intent: intent
    }));
  });
};
AlertText.ssr = false;
 false ? 0 : void 0;
AlertText.defaultProps = {
  "static": {
    linkText: 'Saiba mais'
  }
};
/* harmony default export */ var AlertText_AlertText = (AlertText);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AlertText/index.js


/***/ }),

/***/ 7570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AttributeList_AttributeList; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/AttributeList/index.js + 1 modules
var organisms_AttributeList = __webpack_require__(36103);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/commons/index.js + 3 modules
var commons = __webpack_require__(46729);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AttributeList/AttributeList.utils.js




var getSelectedAtributes = function getSelectedAtributes(attributes) {
  var mandatory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return attributes == null ? void 0 : attributes.reduce(function (acc, attribute) {
    return (0,esm_extends/* default */.Z)({}, acc, (0,defineProperty/* default */.Z)({}, attribute.type, !mandatory.length || !mandatory.includes(attribute.type) ? attribute.current : ''));
  }, {});
};
var getAttributes = function getAttributes(attributes, selectedAttributes) {
  return attributes == null ? void 0 : attributes.map(function (attribute) {
    return (0,esm_extends/* default */.Z)({}, attribute, {
      current: selectedAttributes[attribute.type],
      selected: !!selectedAttributes[attribute.type]
    });
  });
};
var getParentAttribute = function getParentAttribute(type, attributes) {
  var index = attributes == null ? void 0 : attributes.findIndex(function (attribute) {
    return attribute.type === type;
  });
  return attributes[index - 1];
};
var getParentAttributeSkus = function getParentAttributeSkus(_ref, variations) {
  var type = _ref.type,
    current = _ref.current;
  return variations == null ? void 0 : variations.reduce(function (acc, variation) {
    if (variation.type === type && variation.value === current) {
      acc.push(variation.id);
    }
    return acc;
  }, []);
};
var getVariations = function getVariations(variations, attributes) {
  return variations == null ? void 0 : variations.filter(function (variation) {
    var parentAttribute = getParentAttribute(variation.type, attributes);
    if (!parentAttribute) return true;
    if (!parentAttribute.selected) return false;
    var skus = getParentAttributeSkus(parentAttribute, variations);
    return skus.includes(variation.id);
  });
};
var getVariationsById = function getVariationsById(variations) {
  return variations == null ? void 0 : variations.reduce(function (acc, variation) {
    if (!variation.available) return acc;
    return (0,esm_extends/* default */.Z)({}, acc, (0,defineProperty/* default */.Z)({}, variation.id, (0,esm_extends/* default */.Z)({}, acc[variation.id] || {}, (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, variation.type, variation.value), "path", variation.path))));
  }, {});
};
var getScore = function getScore(selectedAttributes, variation, attributes) {
  return Object.keys(selectedAttributes).reduce(function (acc, key) {
    if (selectedAttributes[key] === variation[key]) {
      var index = attributes.findIndex(function (_ref2) {
        var type = _ref2.type;
        return type === key;
      });
      var indexScore = index > -1 ? attributes.length - index : 0;
      return acc + 1 + indexScore / 100;
    }
    return acc;
  }, 0);
};
var getMatchedVariation = function getMatchedVariation(selected, variations, attributes) {
  var defaultSelected = getSelectedAtributes(attributes);
  var updatedAttributes = (0,esm_extends/* default */.Z)({}, defaultSelected, (0,defineProperty/* default */.Z)({}, selected.type, selected.value));
  var variationsById = getVariationsById(variations);
  return Object.entries(variationsById).reduce(function (acc, _ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
      sku = _ref4[0],
      variation = _ref4[1];
    if (variation[selected.type] === selected.value) {
      return [].concat((0,toConsumableArray/* default */.Z)(acc), [(0,esm_extends/* default */.Z)({}, variation, {
        id: sku,
        score: getScore(updatedAttributes, variation, attributes)
      })]);
    }
    return acc;
  }, []).sort(function (variationA, variationB) {
    return variationB.score - variationA.score;
  }).shift();
};

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AttributeList/AttributeList.js










var AttributeList = function AttributeList(_ref) {
  var _ref$static = _ref["static"],
    _ref$static$mandatory = _ref$static.mandatorySelectionTypes,
    mandatorySelectionTypes = _ref$static$mandatory === void 0 ? [] : _ref$static$mandatory,
    _ref$static$alignment = _ref$static.alignment,
    alignment = _ref$static$alignment === void 0 ? 'center' : _ref$static$alignment,
    _ref$static$colorMinL = _ref$static.colorMinLength,
    colorMinLength = _ref$static$colorMinL === void 0 ? 10 : _ref$static$colorMinL,
    _ref$static$colorVari = _ref$static.colorVariant,
    colorVariant = _ref$static$colorVari === void 0 ? 'smooth' : _ref$static$colorVari,
    product = _ref.data.product,
    structure = _ref.structure;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish,
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var _structure$route = structure.route,
    productId = _structure$route.productId,
    sellerId = _structure$route.sellerId,
    _structure$basePath = structure.basePath,
    basePath = _structure$basePath === void 0 ? '' : _structure$basePath;
  var attributes = product.attributes,
    variations = product.variations,
    title = product.title;
  var _useState = (0,react.useState)(getSelectedAtributes(attributes, mandatorySelectionTypes)),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    selectedAttributes = _useState2[0],
    setSelectedAttributes = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    showWarningText = _useState4[0],
    setShowWarningText = _useState4[1];
  var _useState5 = (0,react.useState)(''),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    iconWarningText = _useState6[0],
    setIconWarningText = _useState6[1];
  var _useState7 = (0,react.useState)(''),
    _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
    warningText = _useState8[0],
    setWarningText = _useState8[1];
  var attributesList = getAttributes(attributes, selectedAttributes);
  var variationsList = getVariations(variations, attributesList);
  var handlePublishAttributeChange = function handlePublishAttributeChange() {
    publish('product:attribute:change', attributesList);
  };
  var handlePublishVoltageText = function handlePublishVoltageText(externalInfo) {
    var showComponent = externalInfo.showComponent,
      message = externalInfo.message,
      icon = externalInfo.icon;
    setShowWarningText(showComponent);
    setWarningText(message);
    setIconWarningText(icon);
  };
  (0,react.useEffect)(function () {
    subscribe('product:get:attribute', handlePublishAttributeChange);
    handlePublishAttributeChange();
    return function () {
      unsubscribe('product:get:attribute', handlePublishAttributeChange);
    };
  }, [attributesList]);
  (0,react.useEffect)(function () {
    subscribe(commons/* PRODUCT_ATTRIBUTE_LIST_SHOW_WARNING_VOLTAGE_TEXT */.YT, handlePublishVoltageText);
    return function () {
      unsubscribe(commons/* PRODUCT_ATTRIBUTE_LIST_SHOW_WARNING_VOLTAGE_TEXT */.YT, handlePublishVoltageText);
    };
  }, []);
  var handleAttributeChanged = function handleAttributeChanged(_e, selected) {
    var matchedVariation = getMatchedVariation(selected, variations, attributes);
    var updateSelected = Object.entries(selectedAttributes).reduce(function (acc, _ref2) {
      var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
        type = _ref3[0],
        value = _ref3[1];
      if (type === selected.type) {
        acc[selected.type] = selected.value;
      } else if (mandatorySelectionTypes.length && mandatorySelectionTypes.includes(type)) {
        acc[type] = matchedVariation[type] === value ? value : '';
      }
      return acc;
    }, (0,esm_extends/* default */.Z)({}, selectedAttributes));
    var _attributes$find = attributes.find(function (attribute) {
        return attribute.type === selected.type;
      }),
      label = _attributes$find.label;
    publish('product:attribute:click', {
      type: label,
      value: selected.value
    });
    setSelectedAttributes(updateSelected);
    setShowWarningText(false);
    if (matchedVariation.id !== productId) {
      var path = "".concat(basePath, "/").concat(matchedVariation.path, "/?seller_id=").concat(sellerId);
      (0,esm/* routePush */.dY)({
        path: path,
        spa: true
      });
    }
  };
  return react.createElement(organisms_AttributeList/* default */.Z, {
    fullWidth: true,
    title: title,
    alignment: alignment,
    attributes: attributesList,
    variations: variationsList,
    onAttributeChange: handleAttributeChanged,
    colorMinLength: colorMinLength,
    colorVariant: colorVariant,
    showWarningText: showWarningText,
    warningMessage: warningText,
    iconWarningText: iconWarningText
  });
};
 false ? 0 : void 0;
AttributeList.ssr = true;
AttributeList.displayName = 'AttributeList';
AttributeList.dataSource = {
  product: {
    query: 'ProductQuery'
  }
};
/* harmony default export */ var AttributeList_AttributeList = ((0,withLayoutProps/* default */.Z)(AttributeList));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/AttributeList/index.js


/***/ })

}]);